export default __webpack_public_path__ + "static/media/profile-picture.10c7535c.png";